import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import "./ChainOfferCompletionScene.scss";

interface ChainOfferCompletionSceneProps {
    current: number;
    total: number;
}

interface SparkleStyle extends CSSProperties {
    "--spark-index": number;
}

function sparkleStyle(index: number): SparkleStyle {
    return { "--spark-index": index };
}

export function ChainOfferCompletionScene({
    current,
    total,
}: ChainOfferCompletionSceneProps) {
    const { t } = useTranslation();

    return (
        <div
            className="chain-offer-completion-scene"
            role="status"
            aria-live="polite"
        >
            <span
                className="chain-offer-completion-scene__rays"
                aria-hidden="true"
            />
            <span
                className="chain-offer-completion-scene__sparkles"
                aria-hidden="true"
            >
                {Array.from({ length: 10 }).map((_, index) => (
                    <span key={index} style={sparkleStyle(index)} />
                ))}
            </span>
            <span
                className="chain-offer-completion-scene__check"
                aria-hidden="true"
            >
                ✓
            </span>
            <strong className="chain-offer-completion-scene__title">
                {t("commerce.chain.complete")}
            </strong>
            <span className="chain-offer-completion-scene__progress" dir="ltr">
                {t("commerce.chain.progress", { current, total })}
            </span>
        </div>
    );
}
